export default __webpack_public_path__ + "static/media/iconExperience.95082f0a.svg";